'use strict';
import templateUrl from './permissions.html';

export default {
    templateUrl,
    bindings: {},
    controller: [function () {}],
};
